// extracted by mini-css-extract-plugin
module.exports = {"emptyWrap":"empty-favorites-list_emptyWrap__6Bz_v","iconButtonWrapper":"empty-favorites-list_iconButtonWrapper__6OeT9"};